import { StyleSheet, Platform } from 'react-native'
import theme from '../../../theme'
import { colorButtonTextEnabled } from '../../../themeConstants'

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#FFFFFF',
        padding: 15,
    },
    scrollView: {
        flex: 1,
    },
    modalOverlay: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // Fondo semi-transparente
    },
    modalSubtitle: {
        fontSize: 16,
        fontWeight: 'normal',
        marginBottom: 15,
        color: theme.colors.textSecondary,
    },
    modalContainer: {
        width: '80%',
        backgroundColor: 'white',
        borderRadius: 10,
        paddingHorizontal: 12,
        paddingVertical: 20,
        alignItems: 'center',
        // Sombras: usar boxShadow en web, y props nativas en iOS/Android
        ...(Platform.OS === 'web'
            ? { boxShadow: '0px 2px 4px rgba(0,0,0,0.2)' }
            : {
                  elevation: 5,
                  shadowColor: 'black',
                  shadowOffset: { width: 0, height: 2 },
                  shadowOpacity: 0.2,
                  shadowRadius: 4,
              }),
    },
    input_verification: {
        width: '100%',
        height: 40,
        borderColor: theme.colors.lightGray,
        borderWidth: 0.5,
        borderRadius: 5,
        paddingHorizontal: 12,
        marginBottom: 12,
    },
    modalTitle: {
        fontSize: 18,
        fontWeight: 'bold',
        marginBottom: 4,
        color: theme.colors.textPrimary,
    },
    containerEditPhoto: {
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: 20,
    },
    avatar: {
        width: 80,
        aspectRatio: 1,
        borderRadius: 40,
        marginRight: 0,
    },
    containerTextIcon: {
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: 10,
    },
    iconButton: {
        marginHorizontal: 5,
    },
    textButton: {
        fontSize: 14,
        color: theme.colors.colorPrimary,
        fontWeight: 'bold',
    },
    input: {
        height: 40,
        borderWidth: 0.5,
        borderRadius: 5,
        borderColor: theme.colors.lightGray,
        paddingVertical: 10,
        paddingHorizontal: 10,
        marginTop: 4,
        marginBottom: 15,
        alignItems: 'center',
        color: theme.colors.textPrimary,
    },
    inputBlock: {
        flexDirection: 'row',
        width: '100%',
        height: 40,
        borderWidth: 1,
        borderRadius: 10,
        borderColor: theme.colors.lightGray,
        backgroundColor: 'white',
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'space-between',
        paddingHorizontal: 20,
        marginTop: 0,
    },
    dropdown: {
        borderWidth: 0.5,
        borderRadius: 5,
        borderColor: theme.colors.lightGray,
        color: theme.colors.textPrimary,
        marginTop: -2,
        marginBottom: 15,
    },
    dropdownOptions: {
        color: theme.colors.textPrimary,
    },
    dropdownInput: {
        color: theme.colors.textPrimary,
    },
    inputLocked: {
        height: 40,
        marginTop: 5,
        marginBottom: 15,
        borderWidth: 0.5,
        borderRadius: 5,
        borderColor: theme.colors.disabled,
        backgroundColor: theme.colors.disabled,
        color: theme.colors.textSecondary,
        padding: 10,
    },
    tagInput: {
        fontSize: 14,
        color: theme.colors.textPrimary,
        fontWeight: 'bold',
    },
    mainButton: {
        marginTop: 10,
        backgroundColor: theme.colors.colorPrimary,
        padding: 10,
        borderRadius: 10,
    },
    mainButtonText: {
        color: colorButtonTextEnabled,
        fontWeight: 'bold',
        textAlign: 'center',
    },
    accordionText: {
        fontSize: 16,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        marginVertical: 10,
    },
    buttonContainer: {
        flexDirection: 'column',
        width: '100%',
        paddingVertical: 5,
    },
    button: {
        flex: 1,
        paddingVertical: 12,
        borderRadius: 5,
        alignItems: 'center',
    },
    cancelButton: {
        backgroundColor: theme.colors.colorDisapproved,
        marginRight: 10,
    },
    saveButton: {
        backgroundColor: theme.colors.colorPrimary,
        marginLeft: 10,
    },
    buttonText: {
        color: 'white',
        fontWeight: 'bold',
        fontSize: 16,
    },
    borderRedButton: {
        flexDirection: 'row',
        justifyContent: 'center',
        marginTop: 10,
        backgroundColor: 'white',
        borderWidth: 2,
        borderColor: theme.colors.error,
        padding: 8,
        borderRadius: 10,
    },
    borderRedButtonText: {
        color: theme.colors.error,
        fontWeight: 'bold',
        textAlign: 'center',
    },
    deleteBlock: {
        marginTop: 25,
        marginBottom: 12,
        alignItems: 'center',
    },
    deleteText: {
        color: theme.colors.error,
        fontWeight: 'bold',
    },
    containerModal: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        height: '80%',
    },
    image: {
        width: 120,
        height: 120,
    },
    title: {
        fontSize: 18,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'center',
        marginBottom: 5,
        marginTop: 10,
        paddingHorizontal: 24,
    },
    description: {
        fontSize: 16,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textAlign: 'center',
        lineHeight: 20,
        paddingHorizontal: 12,
    },
    borderButton: {
        borderWidth: 2,
        borderColor: theme.colors.colorPrimary,
        paddingVertical: 8,
        paddingHorizontal: 50,
        borderRadius: 10,
    },
    borderButtonText: {
        color: theme.colors.colorPrimary,
        fontWeight: 'bold',
        fontSize: 15,
        textAlign: 'center',
    },
    inputRow: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    data: {
        fontSize: 15,
        fontWeight: 'normal',
    },
    editIcon: {
        justifyContent: 'center',
    },
    marginLeft: {
        marginLeft: 8,
    },
    marginHorizontal: {
        marginHorizontal: 12,
    },
    paddingHorizontal: {
        paddingHorizontal: 12,
    },
    marginBottom: {
        marginBottom: 10,
    },
    spacer1: {
        height: 8,
    },
    containerRow: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
    },
    textVerified: {
        fontSize: 15,
        fontWeight: 'bold',
        color: theme.colors.colorApproved,
        paddingVertical: 0,
    },
    textToVerify: {
        fontSize: 15,
        fontWeight: 'bold',
        color: theme.colors.colorPrimary,
        paddingVertical: 0,
    },
})

export default styles
